import { Log } from './Log';

export class Preloader {
  private readonly _canvas: HTMLCanvasElement;
  private readonly _preloaderSelector: string;

  constructor(canvas: HTMLCanvasElement, preloaderSelector: string) {
    this._canvas = canvas;
    this._preloaderSelector = preloaderSelector;
  }

  hide(): void {
    const img = document.querySelector(this._preloaderSelector) as HTMLDivElement;

    if (img) {
      img.remove();
    }
  }
}
